import React from 'react';

const ApportionmentIcon = ({ fill }) => {
  return (
    <svg t="1605559316005" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3083" xlink="http://www.w3.org/1999/xlink" width="15" height="15">
      <defs>
        <style type="text/css" />
      </defs>
      <path
        d="M642.4 466.8l-216-63.2C401.4 396.4 384 373 384 347c0-32.6 26.4-59 59-59h132.6c24.4 0 48.4 7.4 68.4 21 12.2 8.2 28.6 6.2 39-4l69.6-68c14.2-13.8 12.2-36.8-3.6-49C700 149.6 638.8 128.2 576 128V32c0-17.6-14.4-32-32-32h-64c-17.6 0-32 14.4-32 32v96h-5C315.6 128 213.2 237.4 225 367.2c8.4 92.2 78.8 167.2 167.6 193.2l205 60c25 7.4 42.4 30.6 42.4 56.6 0 32.6-26.4 59-59 59h-132.6C424 736 400 728.6 380 715c-12.2-8.2-28.6-6.2-39 4l-69.6 68c-14.2 13.8-12.2 36.8 3.6 49 49 38.4 110.2 59.8 173 60v96c0 17.6 14.4 32 32 32h64c17.6 0 32-14.4 32-32v-96.4c93.2-1.8 180.6-57.2 211.4-145.4 43-123.2-29.2-249.6-145-283.4z"
        p-id="3084"
        fill={fill}
       />
    </svg>
  );
};

export default ApportionmentIcon;
